<div class="logs-container">
  @if (outputLogsQuery.isLoading()) {
    <app-loading></app-loading>
  }
  @for (log of outputLogsQuery.data()?.logs; track log) {
    <div class="log-item">
      <div class="log-header">
        <span class="log-time">{{ log.time.absolute }}</span>
        <span class="log-type">
          <i [class]="log.output_type.icon_uri"></i> {{ log.output_type.name }}
        </span>
      </div>
      <div class="log-content">
        <div class="log-field">
          <strong>Object:</strong> {{ log.object_name }}
        </div>
        <div class="log-field">
          <strong>Company:</strong> {{ log.company.name }}
        </div>
        <div class="log-field"><strong>User:</strong> {{ log.user.name }}</div>
      </div>
      <div class="log-footer">
        <span
          class="log-error"
          [ngClass]="{
            'error-true': log.output_errors,
            'error-false': !log.output_errors,
          }"
        >
          {{
            log.output_errors
              ? "output-logs.label.has-errors"
              : ("output-logs.label.no-errors" | translate)
          }}
        </span>
      </div>
      <!-- File Download Section -->
      @if (log.files.length > 0) {
        <div class="log-files">
          <strong>{{ "output-logs.label.download-files" | translate }}:</strong>
          <ul>
            @for (file of log.files; track file) {
              <li class="file">
                <a [href]="downloadLog(file.name)" download>
                  <fa-icon
                    class="type-icon"
                    [icon]="getFileTypeIcon(file.output_format.name)"
                  ></fa-icon>
                  <span>{{ file.base_name }}</span>
                  <fa-icon [icon]="['fas', 'download']"></fa-icon>
                </a>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  }
  @if (
    outputLogsQuery.data() &&
    outputLogsQuery.data()?.logs.length == 0 &&
    !outputLogsQuery.isLoading()
  ) {
    <div>
      {{ "output-logs.label.no-logs" | translate }}
    </div>
  }
</div>
